import { Row, RenderConfig, TextInput, NumberInput, Column, EMPTY_ARRAY, CheckboxInput } from 'commons-ui';

export const FORM_FIELD_KEYS = {
	EMAIL: 'email',
	ZUPEE_USER_ID: 'uid',
	PHONE_NUMBER: 'phone',
	ADD_TO_STATIC: 'addToStatic'
};

export const FORM_FIELD_LABELS = {
	[FORM_FIELD_KEYS.EMAIL]: 'Email',
	[FORM_FIELD_KEYS.ZUPEE_USER_ID]: 'Zupee User Id',
	[FORM_FIELD_KEYS.PHONE_NUMBER]: 'Phone Number',
	[FORM_FIELD_KEYS.ADD_TO_STATIC]: 'Add to Static'
};

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.EMAIL]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.EMAIL)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.EMAIL])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } }
		}),
	[FORM_FIELD_KEYS.ZUPEE_USER_ID]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.ZUPEE_USER_ID)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.ZUPEE_USER_ID])
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } }
		}),
	[FORM_FIELD_KEYS.PHONE_NUMBER]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.PHONE_NUMBER)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.PHONE_NUMBER])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } }
		}),
	[FORM_FIELD_KEYS.ADD_TO_STATIC]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.ADD_TO_STATIC)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.ADD_TO_STATIC])
		.setRenderer(CheckboxInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } },
			checked: false
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.ZUPEE_USER_ID)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.PHONE_NUMBER)]), new Column([new Row(FORM_FIELD_KEYS.EMAIL)])]),
	new Row(FORM_FIELD_KEYS.ADD_TO_STATIC)
];
